import React from 'react'
import type { UserAvatarProps } from '@ztechapps/webui.input'
import { UserAvatar } from '@ztechapps/webui.input'

export const CustomerAvatar = (props: UserAvatarProps) => {
  return <UserAvatar {...props} />
}
